
import nav0Icon from "@/assets/imgs/wifiDetector/nav-0.png";
import nav0ActiveIcon from "@/assets/imgs/wifiDetector/nav-0-active.png";
import nav1Icon from "@/assets/imgs/wifiDetector/nav-1.png";
import nav1ActiveIcon from "@/assets/imgs/wifiDetector/nav-1-active.png";
import nav2Icon from "@/assets/imgs/wifiDetector/nav-2.png";
import nav3Icon from "@/assets/imgs/wifiDetector/nav-3.png";
import nav3ActiveIcon from "@/assets/imgs/wifiDetector/nav-3-active.png";
import androidCodeImg from "~/assets/imgs/smproapp/android-code.png";
import { HELP_SUPPORT_URL } from "~/api/api-list";
// import {queryPrivateUrl} from "~/utils/queryPrivateUrl";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      videoButton: true,
      videoControls: false,
      androidCodeImg,
      videoUrl:
        "https://file2.speedtest.cn/videos/bluetooth-wifi/bluetooth-wifi.mp4",
      videoBg: require("@/assets/imgs/wifiDetector/video-bg.jpg"),
      applicationList: [
        {
          title: "家庭网络精准调优",
          banner: require("@/assets/imgs/wifiDetector/application-0.png"),
          question:
            "卧室/书房Wi-Fi信号差，追剧、打游戏、刷视频卡顿，网速时快时慢不稳定，无法定位网络问题",
          solveList: [
            "手持检测仪全屋走动，查看各关键区域的信号强度变化趋势情况，寻找最佳上网点",
            "对比2.4GHz/5GHz频段下各区域的信号强度变化趋势，选择最佳频段",
          ],
        },
        {
          title: "公共办公网络急救",
          banner: require("@/assets/imgs/wifiDetector/application-1.png"),
          question:
            "连接咖啡厅公共网络，使用iPad+Apple Pencil云端同步资料时频繁断线，无法区分是网络问题还是iOS沙盒机制限制",
          solveList: [
            "基于iOS的802.11ax优化协议（如目标唤醒时间TWT），推荐iPhone/iPad优先使用的节能信道",
            "根据信号强度和干扰值，选择合适的区域办公",
          ],
        },
        {
          title: "企业级苹果设备网络运维",
          banner: require("@/assets/imgs/wifiDetector/application-2.png"),
          question:
            "企业总部部署数百台iPad POS机，因Wi-Fi漫游延迟导致Apple Pay交易失败",
          solveList: [
            "实时显示Wi-Fi信号趋势，分析信号强度变化情况",
            "根据在线设备及信号干扰图，分析排除影响网络的原因",
          ],
        },
      ],
      useList: [
        {
          titile: "安装专业Wi-Fi分析软件",
          val: '苹果应用商店搜索并安装测速网或在官网安装<a href="/smpro" target="_blank">网维助手APP</a>',
        },
        {
          titile: "Wi-Fi检测仪插入电源",
          val: "通过转接线将Wi-Fi检测仪连接到iPhone手机或充电宝上，检测仪指示灯亮起则表示通电成功",
        },
        {
          titile: "连接设备",
          val: "运行【测速网】APP(首页)/【网维助手】APP(工具箱)，打开「Wi-Fi分析工具」连接蓝牙设备【CSW-WiFi-070520】",
        },
        {
          titile: "连接Wi-Fi",
          val: "设备连接成功后会自动扫描周边Wi-Fi，请手动选择并连接您要检测的目标Wi-Fi网络（需输入Wi-Fi密码），连接成功即可查看具体的Wi-Fi信息",
        },
      ],
      questionList: [
        {
          title: "Q1：这款Wi-Fi信号检测仪适合哪些设备使用？",
          list: [
            "· 本款Wi-Fi信号检测仪专为iOS系统设计开发，适合iPhone及iPad所有机型",
          ],
        },
        {
          title: "Q2：Wi-Fi信号检测仪上的灯代表什么意思？",
          list: [
            "· 设备通电成功：指示灯慢闪烁，2s一次",
            "· 蓝牙连接成功：指示灯常亮",
          ],
        },
        {
          title: "Q3：手机连接检测仪时未发现设备？",
          list: [
            "·  Wi-Fi检测仪是通过蓝牙信号与iPhone / iPad设备连接，2个设备距离尽量保持在10米以内。如果距离很近仍然未找到设备，则可将检测仪断电后重新通电",
          ],
        },
        {
          title: "Q4：Wi-Fi分析软件是免费的吗？",
          list: ["·  iOS端，测速网APP和网维助手APP中的Wi-Fi分析工具是免费的"],
        },
      ],
      fnList: [
        {
          title: "网络测速",
          icon: require("@/assets/imgs/wifiDetector/fn-0.svg"),
        },
        {
          title: "固网/Wi-Fi测试",
          icon: require("@/assets/imgs/wifiDetector/fn-1.svg"),
        },
        {
          title: "移动网络测试",
          icon: require("@/assets/imgs/wifiDetector/fn-2.svg"),
        },
        {
          title: "业务感知测试",
          icon: require("@/assets/imgs/wifiDetector/fn-3.svg"),
        },
      ],
      navList: [
        {
          active: false,
          title: "会员开通",
          icon: nav0Icon,
          activeIcon: nav0ActiveIcon,
          type: "pay",
        },
        {
          active: false,
          title: "安装<br/>网维助手<br/>APP",
          icon: nav1Icon,
          activeIcon: nav1ActiveIcon,
          type: "download",
        },
        {
          active: false,
          title: "客服咨询",
          icon: nav2Icon,
          activeIcon: nav2Icon,
          type: "kf",
        },
        {
          active: false,
          title: "返回顶部",
          icon: nav3Icon,
          activeIcon: nav3ActiveIcon,
          type: "top",
        },
      ],
    };
  },
  computed: {
    ...mapState(["bluetoochStartTime", "bluetoochEndTime"]),
  },
  methods: {
    ...mapActions(["setBluetoochSwitch"]),
    /**
     * 跳转网维助手会员支付页
     * */
    gotoPayPage() {
      this.$router.push("/smpro/payment");
    },
    /**
     * 跳转到网维助手页
     * */
    gotoSmproPage() {
      window.open(window.location.origin + "/smpro");
    },
    /**
     * 回到顶部
     * */
    gotoTop() {
      this.$refs.socllBox.scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
    /**
     * 导航栏事件
     * */
    gotoNav(type) {
      if (type === "pay") {
        this.gotoPayPage();
      }
      if (type === "download") {
        this.gotoSmproPage();
      }
      if (type === "kf") {
        window.open(HELP_SUPPORT_URL);
      }
      if (type === "top") {
        this.gotoTop();
      }
    },
    /**
     * 视频播放
     * */
    fullScreen() {
      this.videoControls = true;
      this.videoButton = false;
      const ref = this.$refs.videoPlayer;
      const video = ref && ref.player ? ref.player : ref;
      if (!video) {
        return;
      }
      if (video.play) {
        video.play();
      }
    },
  },
  mounted() {
    this.setBluetoochSwitch();
    // queryPrivateUrl('videos/bluetooth-wifi/bluetooth-wifi.mp4').then(res=>{
    //   this.videoUrl=res
    // })
  },
};
